import React, { useState } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import Typography from '@material-ui/core/Typography';

import { useHistory } from "react-router-dom";





import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";




export default function CadastrarTaxa() {
    const history = useHistory();


    const [estadoBotaoSalvar, setEstadoBotaoSalvar] = useState(false);
    const [nome, setNome] = useState('');
    const [descricao, setDescricao] = useState(''); // Add this line

    const [valor, setValor] = useState(0);
        const [tipoTaxa, setTipoTaxa] = useState(0);
        const [areaTaxa, setAreaTaxa] = useState(0);



    async function salvar() {
        setEstadoBotaoSalvar(true);
        console.log("Salvar chamado");
        try {

            const cadastro = {

                nome: nome,
                descricao: descricao,
                valor: valor,
                tipo_taxa: tipoTaxa,
                area_taxa: areaTaxa,

            };

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.post('/v1/protected/financeiro/taxas/cadastrar', cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Taxa cadastrada com sucesso!")

                history.push({
                    pathname: '/gestao/financas/taxas/listar',
                })
            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente!");
            setEstadoBotaoSalvar(false);
        }




    }






    return (
        <div>
            <NavegadorGestao
                Financas={true}
                TabelasAuxiliaresFinancas={true}
                Taxas={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />
            <Container style={{ paddingTop: 5 }} >
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    item xs={10}
                >
                    <Button style={{ margin: 5 }}
                        variant="contained"
                        color="primary"
                        onClick={salvar}
                        disabled={estadoBotaoSalvar}
                    > Salvar  </Button>
                </Grid>
                <React.Fragment >
                    <Grid container spacing={2}   >



                        <Grid
                            container
                            direction="row"
                            item xs={12}
                            spacing={2}>




                            <Grid item xs={4} >
                                <TextField
                                    variant="standard"
                                    name="nome"
                                    label="Nome"
                                    required
                                    id="nome"
                                    value={nome}
                                    onChange={e => setNome(e.target.value)}
                                    inputProps={{ maxLength: 50, minLength: 1 }}
                                    fullWidth

                                />
                            </Grid>

                            <Grid item xs={12}  >
                                <TextField

                                    variant="standard"
                                    name="descricao"
                                    label="Descrição"
                                    id="descricao"
                                    value={descricao}
                                    onChange={e => setDescricao(e.target.value)}
                                    inputProps={{ maxLength: 600, minLength: 0 }}
                                    fullWidth

                                />
                            </Grid>

                             <TextField
                                                                        variant="standard"
                                                                        name="valor"
                                                                        label="Valor(em %)"
                                                                        id="valor"
                                                                        value={valor}
                                                                      onChange={(e) => setValor(e.target.value)}
                                                                        fullWidth
                                                                    />

                                                                     <FormControl variant="standard" fullWidth>
        <InputLabel id="tipo-taxa-label">Tipo da Taxa</InputLabel>
        <Select
          labelId="tipo-taxa-label"
          id="tipo_taxa"
          name="tipo_taxa"
          value={tipoTaxa}
          onChange={(e) => setTipoTaxa(e.target.value)}
        >
          <MenuItem value={0}>Despesa</MenuItem>
          <MenuItem value={1}>Receita</MenuItem>
        </Select>
      </FormControl>

      {/* Select de Área da Taxa */}
      <FormControl variant="standard" fullWidth>
        <InputLabel id="area-taxa-label">Área da Taxa</InputLabel>
        <Select
          labelId="area-taxa-label"
          id="area_taxa"
          name="area_taxa"
          value={areaTaxa}
          onChange={(e) => setAreaTaxa(e.target.value)}
        >
          <MenuItem value={0}>Insumos</MenuItem>
          <MenuItem value={1}>Custos Operacionais</MenuItem>
        </Select>
      </FormControl>
 

                        </Grid>


                        
  

                    </Grid>



                </React.Fragment>



            </Container>

        </div >
    );
}


